module.exports = __webpack_public_path__ + "img/game_verification_1_pt.c78d2cfe.png";